import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorResponse } from 'src/app/models/error.model';
import { TipoDescuento } from 'src/app/models/tipo-descuento.model';
import { TiposDescuentoService } from 'src/app/services/tipos-descuento.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
    selector: 'app-edit-tipo-descuento',
    templateUrl: './edit-tipo-descuento.component.html',
    styleUrls: ['./edit-tipo-descuento.component.scss']
})
export class EditTipoDescuentoComponent implements OnInit {

    tipoDescuento?: TipoDescuento;

    form = new UntypedFormGroup({
        nombre: new UntypedFormControl('', [Validators.required]),
        tope: new UntypedFormControl(null, [Validators.required, Validators.min(0), Validators.max(100)]),
        activo: new UntypedFormControl(true, [Validators.required])
    });

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private tiposDescuentoService: TiposDescuentoService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params?.id) {
                this.tiposDescuentoService.getTipoDescuentoById(params.id).subscribe({
                    next: td => {
                        this.tipoDescuento = td;
                        this.form.setValue({
                            nombre: td.nombre,
                            tope: td.tope,
                            activo: td.activo
                        });
                    },
                    error: (error: ErrorResponse) => this.utilsService.alert('Error al obtener el tipo de descuento', error.error?.descripcion)
                });
            }
        });
    }

    save() {
        if (!this.form.valid) {
            this.form.markAllAsTouched();
            return;
        }
        const v = this.form.value;
        const payload: TipoDescuento = {
            nombre: v.nombre,
            tope: v.tope,
            activo: v.activo
        };
        if (this.tipoDescuento) {
            this.tiposDescuentoService.updateTipoDescuento({ ...payload, id: this.tipoDescuento.id }).subscribe({
                next: () => {
                    this.utilsService.alert('Tipo de descuento actualizado', `"${payload.nombre}" fue actualizado correctamente.`);
                    this.navigateBack();
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al actualizar', error.error?.descripcion)
            });
        } else {
            this.tiposDescuentoService.createTipoDescuento(payload).subscribe({
                next: () => {
                    this.utilsService.alert('Tipo de descuento creado', `"${payload.nombre}" fue creado correctamente.`);
                    this.navigateBack();
                },
                error: (error: ErrorResponse) => this.utilsService.alert('Error al crear', error.error?.descripcion)
            });
        }
    }

    cancel() {
        this.navigateBack();
    }

    private navigateBack() {
        this.router.navigate(['configuracion', 'calculadora', 'tipos-descuento']);
    }
}
